import React from "react";
import ICONS from "../../constants/game-icons.json";

// Hand-drawn sticker-style icons for the game categories (plus "mix" and "zone"). The markup is a fixed set of
// constants in game-icons.json, never user input; each is drawn on a 64x64 grid with the shared outline style.
export default function GameIcon({ code, size = 56, title }) {
  const inner = ICONS[code];
  if (!inner) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
      style={{ display: "block", flexShrink: 0 }}
    >
      <g stroke="#25204A" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" dangerouslySetInnerHTML={{ __html: inner }} />
    </svg>
  );
}
